<template>
  <v-container fluid pa-0 ma-0>
    <v-layout :id="'printable-receipt-' + transaction.tracking_id" hidden-screen-only>
      <v-container fill-height pa-0 ma-0>
        <v-layout row wrap>
<div class="invoice-box" style="margin: auto;font-size: 16px;line-height: 24px;font-family: 'Helvetica Neue', 'Helvetica', Helvetica, Arial, sans-serif;color: #555;">
<table cellpadding="0" cellspacing="0" style="width: 100%;line-height: inherit;text-align: left;">

<tr>
<td colspan="2" style="font-size: 12px;line-height: 12px;padding-bottom: 10px;text-align: center;">
<font color="#44A9E2">
<div v-if="transaction.account_receipt_header_1">{{ transaction.account_receipt_header_1 }}</div>
<div v-if="transaction.account_receipt_header_2">{{ transaction.account_receipt_header_2 }}</div>
<div v-if="transaction.account_receipt_header_3">{{ transaction.account_receipt_header_3 }}</div>
</font>
</td>
</tr>

<tr class="top">
<td colspan="2" style="padding: 5px;vertical-align: top;">
<table style="width: 100%;line-height: inherit;text-align: left;">
<tr>
<td class="title" style="padding: 5px;vertical-align: top;font-size: 45px;line-height: 45px;color: #333;">
<div v-if="transaction.account_logo">
<img :src="imageUrl + '/' + transaction.account_logo" style="max-width:242px; max-height:100px;" />
</div>
</td>
<td style="padding: 5px;vertical-align: top;text-align: right;">
<h1 v-if="resolvedLegLabel">{{ resolvedLegLabel }} RECEIPT</h1>
<h1 v-else-if="transaction.request_type === 'credit' || transaction.request_type === 'achcredit'">REFUND RECEIPT</h1>
<h1 v-else-if="transaction.request_type === 'void' || transaction.request_type === 'achvoid'">VOID RECEIPT</h1>
<h1 v-else>RECEIPT</h1>
</td>
</tr>
</table>
</td>
</tr>

<tr class="information">
<td colspan="2" style="padding: 5px;vertical-align: top;">
<table style="width: 100%;line-height: inherit;text-align: left;">
<tr>
<td style="padding: 5px;vertical-align: top;padding-bottom: 20px;">
<h3>Thank you for your payment. <br>
<br>
Please keep this receipt for your records.</h3><br>
<b><font color="#44A9E2">Billing Details</font></b><br>
<span v-if="transaction.billing_name">{{ transaction.billing_name }}<br></span>
<span v-if="transaction.billing_address">{{ transaction.billing_address }}<br></span>
<span v-if="transaction.billing_city || transaction.billing_state || transaction.billing_postal_code"><span v-if="transaction.billing_city">{{ transaction.billing_city }},</span> {{ transaction.billing_state }} {{ transaction.billing_postal_code }}<br></span>
<span v-if="transaction.billing_country">{{ transaction.billing_country }}</span>
</td>

<td style="padding: 5px;vertical-align: top;text-align: right;padding-bottom: 20px;">
<b><font color="#44A9E2">Merchant</font></b><br>
{{ transaction.account_name }}<br>
{{ transaction.account_street_1 }}<br>
<span v-if="transaction.account_street_2">{{ transaction.account_street_2 }}<br></span>
{{ transaction.account_city }}, {{ transaction.account_state }} {{ transaction.account_zip }}<br>
<span v-if="transaction.account_phone">{{ phone(transaction.account_phone) }}<br></span>
<span v-if="transaction.account_email && !accountPermissions.hide_email_on_receipt">{{ transaction.account_email }}</span>
<br>&nbsp;<br>
<span v-if="transaction.customer_po">Customer PO: {{ transaction.customer_po }}<br></span>
<span v-if="transaction.custom_field_1">{{ transaction.custom_field_1 }}<br></span>
<span v-if="transaction.custom_field_2">{{ transaction.custom_field_2 }}<br></span>
<span v-if="transaction.custom_field_3">{{ transaction.custom_field_3 }}<br></span>

</td>
</tr>
</table>
</td>
</tr>

<tr class="heading">
<td style="padding: 5px;vertical-align: top;background: #eee;border-bottom: 1px solid #ddd;font-weight: bold;">
Merchant ID:
</td>
<td style="padding: 5px;vertical-align: top;text-align: right;background: #eee;border-bottom: 1px solid #ddd;font-weight: bold;">
******{{ transaction.merchant_id ? transaction.merchant_id.toString().slice(-4) : '' }}
</td>
</tr>

<tr class="heading">
<td style="padding: 5px;vertical-align: top;background: #eee;border-bottom: 1px solid #ddd;font-weight: bold;">
Terminal ID:
</td>

<td style="padding: 5px;vertical-align: top;text-align: right;background: #eee;border-bottom: 1px solid #ddd;font-weight: bold;">
********{{ transaction.terminal_code ? transaction.terminal_code.slice(-4) : '' }}
</td>
</tr>

<tr class="heading">
<td style="padding: 5px;vertical-align: top;background: #eee;border-bottom: 1px solid #ddd;font-weight: bold;">
Transaction ID:
</td>

<td style="padding: 5px;vertical-align: top;text-align: right;background: #eee;border-bottom: 1px solid #ddd;font-weight: bold;">
{{ transaction.tracking_id }}
</td>
</tr>

<tr class="item">
<td style="padding: 5px;vertical-align: top;border-bottom: 1px solid #eee;">
Time:
</td>

<td style="padding: 5px;vertical-align: top;text-align: right;border-bottom: 1px solid #eee;">
{{ datetime(transaction.settled ? transaction.settled : (transaction.authorized ? transaction.authorized : transaction.created)) }}
</td>
</tr>

<tr class="item" v-if="transaction.payment_type !== 'ach'">
<td style="padding: 5px;vertical-align: top;border-bottom: 1px solid #eee;">
Auth No.:
</td>

<td style="padding: 5px;vertical-align: top;text-align: right;border-bottom: 1px solid #eee;">
{{ transaction.auth_code }}
</td>
</tr>

<tr class="item">
<td style="padding: 5px;vertical-align: top;border-bottom: 1px solid #eee;">
<font color="#44A9E2">{{ transaction.payment_type ? transaction.payment_type.toUpperCase() : '' }}</font>
</td>

<td style="padding: 5px;vertical-align: top;text-align: right;border-bottom: 1px solid #eee;">
<template v-if="transaction.payment_type === 'ach'">
<font color="#44A9E2">**********{{ transaction.last_four }}</font>
</template>
<template v-else>
<font color="#44A9E2">**** **** **** {{ transaction.last_four }}</font>
</template>
</td>
</tr>

<template v-if="!(accountPermissions.hasOwnProperty('has_hidden_cash_discount') && accountPermissions.has_hidden_cash_discount)">
<tr class="item last">
<td style="padding: 5px;vertical-align: top;border-bottom: none;">
Sub total:
</td>

<td style="padding: 5px;vertical-align: top;text-align: right;border-bottom: none;">
<template v-if="transaction.request_type === 'sale' || transaction.request_type === 'ach'">
${{ ((transaction.total_amount - transaction.fee_amount - transaction.tax_amount) / 100).toFixed(2) }}
</template>
<template v-else>
${{ ((transaction.parent_total_amount - transaction.parent_fee_amount - transaction.parent_tax_amount) / 100).toFixed(2) }}
</template>
</td>
</tr>
</template>

<template v-if="transaction.is_cashdiscount && transaction.payment_type !== 'ach' && transaction.payment_type !== 'achvoid' && transaction.payment_type !== 'achcredit' && transaction.payment_type !== 'credit' && !(accountPermissions.hasOwnProperty('has_hidden_cash_discount') && accountPermissions.has_hidden_cash_discount)">
<tr class="item">
<td style="padding: 5px;vertical-align: top;border-bottom: 1px solid #eee;">
Price Adjustment Fee:
</td>
<td style="padding: 5px;vertical-align: top;text-align: right;border-bottom: 1px solid #eee;">
<template v-if="transaction.request_type === 'sale'">
${{ (transaction.fee_amount / 100).toFixed(2) }}
</template>
<template v-else>
${{ (transaction.parent_fee_amount / 100).toFixed(2) }}
</template>
</td>
</tr>
</template>

<template v-if="transaction.request_type === 'void' || transaction.request_type === 'achvoid'">
<tr class="item">
<td style="padding: 5px;vertical-align: top;border-bottom: 1px solid #eee;">
Void:
</td>
<td style="padding: 5px;vertical-align: top;text-align: right;border-bottom: 1px solid #eee;">
(${{ (transaction.parent_total_amount / 100).toFixed(2) }})
</td>
</tr>
</template>

<template v-if="transaction.request_type === 'credit' || transaction.request_type === 'achcredit'">
<tr class="item">
<td style="padding: 5px;vertical-align: top;border-bottom: 1px solid #eee;">
Refund:
</td>
<td style="padding: 5px;vertical-align: top;text-align: right;border-bottom: 1px solid #eee;">
(${{ (transaction.total_amount / 100).toFixed(2) }})
</td>
</tr>
</template>

<tr class="total">
<td style="padding: 5px;vertical-align: top;"></td>
<td style="padding: 5px;vertical-align: top;text-align: right;border-top: 2px solid #9aD1f0;font-weight: bold;">
<template v-if="resolvedLegLabel && (transaction.request_type === 'void' || transaction.request_type === 'achvoid')">
{{ resolvedLegLabel }} AMOUNT: (${{ (transaction.parent_total_amount / 100).toFixed(2) }})
</template>
<template v-else-if="resolvedLegLabel && (transaction.request_type === 'credit' || transaction.request_type === 'achcredit')">
{{ resolvedLegLabel }} AMOUNT: (${{ (transaction.total_amount / 100).toFixed(2) }})
</template>
<template v-else-if="resolvedLegLabel">
{{ resolvedLegLabel }} AMOUNT: ${{ (transaction.total_amount / 100).toFixed(2) }}
</template>
<template v-else-if="transaction.request_type === 'void' || transaction.request_type === 'achvoid'">
VOID AMOUNT: (${{ (transaction.parent_total_amount / 100).toFixed(2) }})
</template>
<template v-else-if="transaction.request_type === 'credit' || transaction.request_type === 'achcredit'">
REFUND AMOUNT: (${{ (transaction.total_amount / 100).toFixed(2) }})
</template>
<template v-else>
SALE AMOUNT: ${{ (transaction.total_amount / 100).toFixed(2) }}
</template>
</td>
</tr>

</table>

<div style="bottom: 0;margin: 10px;position: absolute;width: 100%;">
<table cellpadding="0" cellspacing="0" style="width: 100%;line-height: inherit;text-align: center;">
<tr>
<td style="font-size: 12px;line-height: 12px;padding-top: 50px;text-align: center;">
<font color="#44A9E2">
<div v-if="transaction.account_receipt_footer_1">{{ transaction.account_receipt_footer_1 }}</div>
<div v-if="transaction.account_receipt_footer_2">{{ transaction.account_receipt_footer_2 }}</div>
<div v-if="transaction.account_receipt_footer_3">{{ transaction.account_receipt_footer_3 }}</div>
</font>
</td>
</tr>
</table>
</div>

</div>
        </v-layout>

      </v-container>
    </v-layout>
  </v-container>
</template>

<script>
import { Printd } from 'printd'

import ApiMixin from '@/mixins/api'
import AuthMixin from '@/mixins/auth'
import DisplayMixin from '@/mixins/display'
import StoreMixin from '@/store/mixin'

export default {
  mixins: [ApiMixin, AuthMixin, DisplayMixin, StoreMixin],

  data: function () {
    return {
      enabled: false,
      imageUrl: process.env.VUE_APP_IMAGE_URL || 'https://paynetworx-dev-images.s3.us-west-2.amazonaws.com'
    }
  },

  props: {
    transaction: Object,
    legLabel: { type: String, default: null }
  },

  computed: {
    resolvedLegLabel: function () {
      if (this.legLabel) {
        return this.legLabel
      }
      const c = this.transaction && this.transaction.custom
      let parsed = c
      if (typeof c === 'string') {
        try {
          parsed = JSON.parse(c)
        } catch (e) {
          parsed = null
        }
      }
      const label = parsed && parsed.receipt_label
      if (typeof label === 'string' && /^[A-Z0-9 _-]{1,32}$/.test(label)) {
        return label
      }
      return null
    },
    accountPermissions: function () {
      let accountPermissions = {}

      if (this.transaction && this.transaction.hasOwnProperty('account_permissions') && this.transaction.account_permissions) {
        if (typeof this.transaction.account_permissions === 'object') {
          accountPermissions = this.transaction.account_permissions
        } else {
          try {
            accountPermissions = JSON.parse(this.transaction.account_permissions)
          } catch (error) {
            accountPermissions = {}
          }
        }
      }

      return accountPermissions
    }
  },

  mounted () {
    if (process.env.NODE_ENV === 'production') {
      this.imageUrl = process.env.VUE_APP_IMAGE_URL || 'https://paynetworx-images.s3.us-west-2.amazonaws.com'
    }
  },

  methods: {
    print () {
      // handle page title change which is used for 'save as pdf'
      const printCallback = ({ launchPrint }) => {
        document.title = 'Transaction Receipt'
        launchPrint()
      }
      const printd = new Printd()
      printd.print(document.getElementById('printable-receipt-' + this.transaction.tracking_id), [], [], printCallback)
    },
    email () {},
    save () {}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/transactions/ReceiptPrint.vue